<form [formGroup]="form">

  <div class="flex margin-top-15 f-gap--10px" formGroupName="itPmElite">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">IT PM ELITE</mat-card-title>
        <howden-label-value
          class="f-basis--2 group-result-rmbonus"
          [value]="itPmElite.productName || ''">
        </howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex f-gap--10px" style="align-items:flex-start;">

          <div class="f-basis--6 flex f-gap--10px">
            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.itPmEliteSubsudio">Subsidio al día</mat-label>
                <input matInput type="number" formControlName="itPmEliteSubsidy" [howdenMax]="9999999"/>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.ITPMElite_franchise">Franquicia</mat-label>
                <mat-select formControlName="itPmEliteFranchise" [compareWith]="compareByIdNumber">
                  @for (opt of itPmElite.getMasterValues('itPmEliteFranchise'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--3">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.ITPMElite_duration">Duración de la cobertura</mat-label>
                <mat-select formControlName="itPmEliteDuration" [compareWith]="compareByIdNumber">
                  @for (opt of itPmElite.getMasterValues('itPmEliteDuration'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.itPmEliteSubsudio">Hospitalización médica</mat-label>
                <input matInput type="number" formControlName="itPmEliteHospitalization" [howdenMax]="9999999"/>
                <mat-error></mat-error>
              </mat-form-field>
            </div>
          </div>

          @if (showTrace(itPmElite)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(itPmElite) || ''"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (itPmElite.chargeable) {
              <howden-label-value labelText="Prima" [value]="itPmElite.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(itPmElite); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }

            @for (m of getMessages(itPmElite); track $index) {
              @if (!m.blocking) {
                <br />
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              }
            }
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>

  @if (canChargeITPMCoeg) {
    <div class="flex margin-top-15 f-gap--10px" formGroupName="itPmCoeg">
      <mat-card appearance="outlined">
        <mat-card-header class="flex f-jc--center">
          <mat-card-title>IT PM ESPECIAL COEG</mat-card-title>
          <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="itPmCoeg.productName || ''"></howden-label-value>
        </mat-card-header>

        <mat-divider></mat-divider>

        <mat-card-content class="margin-top-15">
          <div class="flex f-gap--10px" style="align-items:flex-start;">

            <div class="f-basis--6 flex f-gap--10px">
              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label>Subsidio al día</mat-label>
                  <input matInput type="number" formControlName="itPmCoegSubsidy" [howdenMax]="9999999"/>
                  <mat-error></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label>Franquicia</mat-label>
                  <mat-select formControlName="itPmCoegFranchise" [compareWith]="compareByIdNumber">
                    @for (opt of itPmCoeg.getMasterValues('itPmCoegFranchise'); track opt.id) {
                      <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                    }
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--3">
                <mat-form-field class="field-inputs">
                  <mat-label>Duración de la cobertura</mat-label>
                  <mat-select formControlName="itPmCoegDuration" [compareWith]="compareByIdNumber">
                    @for (opt of itPmCoeg.getMasterValues('itPmCoegDuration'); track opt.id) {
                      <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                    }
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
              </div>
            </div>

            @if (showTrace(itPmCoeg)) {
              <div class="f-basis--4">
                <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(itPmCoeg) || ''"></div>
              </div>
            }

            <div class="f-basis--2 group-result-rmbonus">
              @if (itPmCoeg.chargeable) {
                <howden-label-value labelText="Prima" [value]="itPmCoeg.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(itPmCoeg); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(itPmCoeg); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            </div>

          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }

  <div class="flex margin-top-15 f-gap--10px" formGroupName="itSurnePlus">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title>IT SURNE PLUS</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="itSurnePlus.productName || ''"></howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex f-gap--10px" style="align-items:flex-start;">

          <div class="f-basis--6 flex f-gap--10px">
            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Subsidio al día</mat-label>
                <input matInput type="number" formControlName="itSurnePlusSubsidy" [howdenMax]="9999999"/>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Franquicia</mat-label>
                <mat-select formControlName="itSurnePlusFranchise" [compareWith]="compareByIdNumber">
                  @for (opt of itSurnePlus.getMasterValues('itSurnePlusFranchise'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--3">
              <mat-form-field class="field-inputs">
                <mat-label>Duración de la cobertura</mat-label>
                <mat-select formControlName="itSurnePlusDuration" [compareWith]="compareByIdNumber">
                  @for (opt of itSurnePlus.getMasterValues('itSurnePlusDuration'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Hospitalización médica</mat-label>
                <input matInput type="number" formControlName="itSurnePlusHospitalization" [howdenMax]="9999999"/>
                <mat-error></mat-error>
              </mat-form-field>
            </div>
          </div>

          @if (showTrace(itSurnePlus)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(itSurnePlus) || ''"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (itSurnePlus.chargeable) {
              <howden-label-value labelText="Prima" [value]="itSurnePlus.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(itSurnePlus); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }

            @for (m of getMessages(itSurnePlus); track $index) {
              @if (!m.blocking) {
                <br />
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              }
            }
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="itSurneVip">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title>IT SURNE VIP</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="itSurneVip.productName || ''"></howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex f-gap--10px" style="align-items:flex-start;">

          <div class="f-basis--6 flex f-gap--10px">
            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Subsidio al día</mat-label>
                <input matInput type="number" formControlName="itSurneVipSubsidy" [howdenMax]="9999999"/>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Franquicia</mat-label>
                <mat-select formControlName="itSurneVipFranchise" [compareWith]="compareByIdNumber">
                  @for (opt of itSurneVip.getMasterValues('itSurneVipFranchise'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--3">
              <mat-form-field class="field-inputs">
                <mat-label>Duración de la cobertura</mat-label>
                <mat-select formControlName="itSurneVipDuration" [compareWith]="compareByIdNumber">
                  @for (opt of itSurneVip.getMasterValues('itSurneVipDuration'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>
          </div>

          @if (showTrace(itSurneVip)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(itSurneVip) || ''"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (itSurneVip.chargeable) {
              <howden-label-value labelText="Prima" [value]="itSurneVip.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(itSurneVip); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }

            @for (m of getMessages(itSurneVip); track $index) {
              @if (!m.blocking) {
                <br />
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              }
            }
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>

<div class="flex margin-top-15 f-gap--10px" formGroupName="itPrebal">
  <mat-card appearance="outlined">
    <mat-card-header class="flex f-jc--center">
      <mat-card-title>IT PREVIS</mat-card-title>
      <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="itPrebal.productName || ''"></howden-label-value>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content class="margin-top-15">
      <div class="flex f-gap--10px" style="align-items:flex-start;">

        <div class="f-basis--6">

          <div class="flex f-gap--10px">
            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Subsidio al día</mat-label>
                <input matInput type="number" formControlName="itPrebalSubsidy" [howdenMax]="9999999"/>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Franquicia</mat-label>
                <mat-select formControlName="itPrebalFranchise" [compareWith]="compareByIdNumber">
                  @for (opt of itPrebal.getMasterValues('itPrebalFranchise'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--3">
              <mat-form-field class="field-inputs">
                <mat-label>Duración de la cobertura</mat-label>
                <mat-select formControlName="itPrebalDuration" [compareWith]="compareByIdNumber">
                  @for (opt of itPrebal.getMasterValues('itPrebalDuration'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex f-gap--10px">
            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label>Hospitalización médica</mat-label>
                <input matInput type="number" formControlName="itPrebalHospitalization" [howdenMax]="9999999"/>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--4">
              <mat-form-field class="field-inputs">
                <mat-label>¿Tiene contrato vida con Previs?</mat-label>
                <mat-select formControlName="itPrebalHasLife" [compareWith]="compareByIdBoolean">
                  @for (opt of itPrebal.getMasterValues('itPrebalHasLife'); track opt.id) {
                    <mat-option [value]="opt.id">{{ opt.description }}</mat-option>
                  }
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>
          </div>

        </div>

        @if (showTrace(itPrebal)) {
          <div class="f-basis--4">
            <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(itPrebal) || ''"></div>
          </div>
        }

        <div class="f-basis--2 group-result-rmbonus">
          @if (itPrebal.chargeable) {
            <howden-label-value labelText="Prima" [value]="itPrebal.bonus | bonus"></howden-label-value>
            <br />
          } @else {
            @for (m of getMessages(itPrebal); track $index) {
              @if (m.blocking) {
                <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
              }
            }
          }

          @for (m of getMessages(itPrebal); track $index) {
            @if (!m.blocking) {
              <br />
              <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
            }
          }
        </div>

      </div>
    </mat-card-content>
  </mat-card>
</div>


</form>
